import {OrbitTheme} from './architecture/orbit-theme.interface';
import {IWindowService} from '../services/window/window.service.interface';
import {Uri} from '../services/location/uri/uri';
import {Check} from '@sparkware/app-utils';
import {Asset, AssetLocationInfo} from './architecture/asset';
import {IStorageService} from "../services/storage/storage.service.interface";
import {ORBIT_LOCATION_OVERRIDE_BASE} from "../services/location/location.service";
import {isMiniOrbitBasePath} from '../services/mini-orbit/mini-orbit-consts';
import { Assets } from './assets';

function resolveAssets(assetsContainer: object, assetLocationInfo: AssetLocationInfo) {
    Object.keys(assetsContainer).forEach(key => {
        let value = assetsContainer[key];
        if(value instanceof Asset) {
            // replaces the Asset instance with a string so
            // If we don't do this then functions like overrideJson will not produce the expected result.
            assetsContainer[key] = value.resolveLocation(assetLocationInfo);
        } else if(Check.isObject(value)) {
            resolveAssets(value, assetLocationInfo);
        }
    });
}

function getThemeName(themeName: string, windowService: IWindowService, storageService: IStorageService): string {

    let baseUri = new Uri(new URL(windowService.location.href)).pathName.getBase().toString();
    if(isMiniOrbitBasePath(baseUri)) {
        return (themeName + baseUri).toLowerCase();
    } else {
        baseUri = storageService.getItem(ORBIT_LOCATION_OVERRIDE_BASE);
        if(isMiniOrbitBasePath(baseUri)) {
            return  (themeName + baseUri).toLowerCase();
        }
    }

    return themeName;
}

export async function  selectTheme(options: {
                                themeName: string;
                                serverPath: string;
                                brandName: string;
                                configurationPath: string;
                                window: IWindowService;
                                storage: IStorageService;
                            }): Promise<OrbitTheme> {

    const themeName = getThemeName(options.themeName, options.window, options.storage) ;

    const themeDefinitionModule = await import(/* webpackChunkName: "theme-definition" */ `./definitions/${themeName}/theme.definition`)

    const themeDefinition: OrbitTheme = themeDefinitionModule.default;

    const assetLocationInfo = {
        brand: options.brandName.toLowerCase(),
        serverPath: options.serverPath.endsWith('/') ? options.serverPath : options.serverPath + '/',
        configurationPath: options.configurationPath.endsWith('/') ? options.configurationPath : options.configurationPath + '/',
    };

    resolveAssets(Assets, assetLocationInfo);

    return themeDefinition;
}


